import { Component } from 'react';
import PropTypes from 'prop-types';

import ModalBoxContext from './context';

class ModalBoxProvider extends Component {
  constructor() {
    super();
    this.state = {
      modal: null,
      options: {
        background: 'rgba(0,0,0,.5)',
        closeOnOutsideClick: true,
        styles: {},
      },
    };
  }

  registerModal = (modal, options = {}) => {
    this.setState((prevState) => ({ modal, options: { ...prevState.options, ...options } }));
  };

  clearModal = () => {
    const options = {
      background: 'rgba(0,0,0,.5)',
      closeOnOutsideClick: true,
      styles: {},
    };
    this.setState({ modal: null, options });
  };

  render() {
    return (
      <ModalBoxContext.Provider
        value={{
          ...this.state,
          registerModal: this.registerModal,
          clearModal: this.clearModal,
        }}
      >
        {this.props.children}
      </ModalBoxContext.Provider>
    );
  }
}

ModalBoxProvider.propTypes = {
  children: PropTypes.any,
};

export default ModalBoxProvider;
